<template>
  <div class="supervise-drug-distribution">
    <div class="patient_list">
        <div class="checkin-btn">
          <van-button type="primary" round color="#0AA8AF" @click="addRecord()" block>新增记录</van-button>
        </div>

        <van-list v-model="loading" :finished="finished" @load="onLoad" >
            <van-cell-group inset class="cell-group" v-for="item,index in list" :key="index">
                <van-cell  :border="false">
                    <template #title><div class="grey_label">省份城市:</div></template>   
                    <div>{{item.province}}{{item.city}}</div>
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">发药药房:</div></template>      
                    <div>{{item.drugstore_name}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">发药日期:</div></template>      
                    <div>{{item.operate_date}}</div> 
                </van-cell>
                <van-cell title="" class="align-right" is-link value="查看详情" @click="showDetail(item)"/>
                <div></div>

            </van-cell-group>

            <template #finished>
                <van-divider :style="{ color: '#bababa', borderColor: '#bababa', padding: '0 80px'}">
                    <div style="width:3px;height:3px;border-radius:100%;background-color:#bababa;"></div>
                </van-divider>
            </template>
        </van-list>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List } from 'vant';
import { Divider } from 'vant';
import { getDrugDispenseList } from '@/api/publicWelfareStaff';
import { mapMutations,mapState } from "vuex";
Vue.use(Divider);
Vue.use(List);
export default {
    data(){
        return {
            //无限加载列表
            list: [],
            loading: false,
            finished: false,

            page:1,
        }
    },
     computed: {
        ...mapState(['publicWelfareStaff']),
    },
    async created(){
        await this.init();
    },
    methods: {
        //   ...mapMutations(['setOriginRoute']),

        async init(){
             
        },
        async fetchData(page){
            let DATA
            let sendData={
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
                page:page
            }
            await getDrugDispenseList(sendData).then(res => {
                if(res.data){
                    DATA=res.data
                    console.log("getDrugDispenseList",res)
                    this.list=[...this.list,...res.data]
                }
            }).catch(err => {

            })
            return DATA
        },
        async onLoad() {
            // 异步更新数据
            await this.fetchData(this.page).then(res => {
                console.log("fetchData",res)
                if (res.length>0) this.page++

                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if (res.length==0) {
                    this.finished = true;
                }
            })
        },
      showDetail(item){
        this.$router.push({name:'superviseDetail',query:{
            drug_dispense_id:item.id
            }})
      },
      addRecord(){
        //存储返回的路径名
        // this.$store.commit("setOriginRoute", this.$route.name);

        this.$router.push({name:'newSupervise',query:{
            // title:'新增监督发药'
            }})
      }
    }
}
</script>

<style lang="scss" scoped>
.supervise-drug-distribution{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    font-size: 16px;
    ::v-deep .grey_label{
        color:#9D9D9D;
        white-space:nowrap;
    }
    .van-search{
        padding:16px;
    }
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .patient_list{
    //   box-shadow: 0 -2px 6px rgba(73, 46, 46, 0.2);
      padding-bottom: 44px;
        .checkin-btn {
            padding: 25px;
        }
        .cell-group{
            margin-bottom:10px;
            .align-right .van-cell__value{
                    text-align: right;
            }
            
            .van-cell__title {
                flex: 1;
                text-align: right;
                margin-right: 10px;
            }
            .van-cell__value{
                flex: 3;
                color:#0A0A0A;
                // white-space:nowrap;
                text-align: left;
                // display:flex;
                // justify-content:flex-start;
                // align-items:center;
                .alignment-flex{
                    display:flex;
                    justify-content:flex-start;
                    align-items:flex-start;
                }
            }
        }
      
    }
}
</style>